import axios from "axios";

const debug = process.env.debug === "true";

export const baseURL = debug
  ? "http://localhost:8083"
  : process.env.vhost_url
    ? process.env.vhost_url
    : "/ae-online-check-in";
export const baseAPIURL = `${baseURL}/api/v0`;
export const marketingBackendURL = process.env.MARKETING_SITE_BACKEND_URL;
export const maintenance = process.env.maintenance === "true";

// A shared instance with configs
export const HTTP = axios.create({
  baseURL: baseAPIURL,
  headers: {
    "content-type": "application/json",
    //   Authorization: 'Bearer {token}'
  },
});

// A shared instance with configs
export const HTTPMarketing = axios.create({
  baseURL: marketingBackendURL,
  headers: {
    "content-type": "application/json",
  },
});



// WEBPACK FOOTER //
// ./src/api/http-common.js